/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

/**
 * @param {Object} obj
 * @returns {Boolean}
 */
export function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]'
}

/**
 * @param {Number} mobile
 * @returns {Boolean}
 */
export function isMobile(mobile) {
  return /^1[3456789]\d{9}$/.test(mobile)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function isEmail(email) {
  const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return emailReg.test(email)
}

/**
 * @param {string} account - 可以是手机号或邮箱
 * @returns {Boolean}
 */
export function isValidAccount(account) {
  if (!account || typeof account !== 'string') {
    return false
  }
  return isMobile(account) || isEmail(account)
}

/**
 * 校验手机号格式
 * @param {string} phone
 * @returns {Boolean}
 */
export function validatePhone(phone) {
  if (!phone || typeof phone !== 'string') {
    return false
  }
  // 中国手机号格式：1开头，第二位是3-9，总共11位
  const phoneReg = /^1[3-9]\d{9}$/
  return phoneReg.test(phone.trim())
}

/**
 * 校验邮箱格式
 * @param {string} email
 * @returns {Boolean}
 */
export function validateEmail(email) {
  if (!email || typeof email !== 'string') {
    return false
  }
  // 更严格的邮箱格式校验
  const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return emailReg.test(email.trim())
}
